
<layout>
<div class="container">
    <h3  >{{config?.whatArePeopleSaying}}</h3>
    <div class=split>
        <div class="group">
            <div class="card" >
                <avatar color="blue">{{config?.testiAvatar1}}</avatar>
                <p class="card-body"> &mdash;{{config?.testiName1}}</p>
                <p class="card-title ">{{config?.testi1}}</p>
            </div>
            <div class="card" >
                <avatar color="black">{{config?.testiAvatar2}}</avatar>
                <p class="card-body"> &mdash;{{config?.testiName2}}</p>
                <p class="card-title ">{{config?.testi2}}</p>
        </div>
        </div>
        <div class="group">
            <div class="card" >
                <avatar color="darkgreen">{{config?.testiAvatar3}}</avatar>
                <p class="card-body"> &mdash;{{config?.testiName3}}</p>
                <p class="card-title ">{{config?.testi3}}</p>
            </div>
            <div class="card" >
                <avatar color="brown">{{config?.testiAvatar4}}</avatar>
                <p class="card-body"> &mdash;{{config?.testiName4}}</p>
                <p class="card-title ">{{config?.testi4}}</p>
            </div>
            <div class="card" >
                <avatar color="aqua">{{config?.testiAvatar5}}</avatar>
                <p class="card-body"> &mdash;{{config?.testiName5}}</p>
                <p class="card-title ">{{config?.testi5}}</p>
            </div>
        </div>
        
    </div>
    <gradient-button *ngIf="!profile?.currentLesson"  (click)=register()>{{config?.mainStartButton}}</gradient-button>
    <gradient-button *ngIf="profile?.currentLesson" (click)=register()>{{this.config?.resume}} {{profile?.currentLesson}}</gradient-button>
</div>
</layout>